import React from "react";
import classNames from "classnames";
import "./ToggleButton.scss";

const ToggleButton = ({
  label,
  disabled,
  value,
  onCheck,
}: {
  label?: string | React.ReactNode;
  disabled?: boolean;
  value: boolean;
  onCheck: (v: boolean) => void;
}) => {
  return (
    <div className={classNames("toggle-button", { disabled })}>
      <label className="toggle-button-label">
        <input
          type="checkbox"
          checked={value}
          onChange={(e) => onCheck(e.target.checked)}
          disabled={disabled}
          className="toggle-button-input"
        />
        <span className={classNames("toggle-button-track", { checked: value })}>
          <span className="toggle-button-thumb" />
        </span>
        <div>{label}</div>
      </label>
    </div>
  );
};

export default ToggleButton;
